// extracted by mini-css-extract-plugin
export default {"hide-button":"styles_hide-button__xDLVA","empty-state__title":"styles_empty-state__title__LIcrF","empty-state__text":"styles_empty-state__text__hrubm"};